export default "__VITE_ASSET__DR99x7uI__"